import { Grid, makeStyles, Paper, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React from "react";


const useStyles = makeStyles({
    padding: {
        padding: 20,
        borderRadius: 8,
    },
    title: {
        fontSize: 18
    },
    paperBack: {
        backgroundColor: "#F9004D"
    },
    number: {
        fontSize: 50,
        fontWeight: "bold"
    }
})

const CardNumber = (props) => {
    const classes = useStyles()

    return (
        <div>
            {
                props.load ?
                    <Skeleton variant="rect" height={120} /> :

                    <Paper elevation={4} className={classes.padding} style={{ backgroundColor: props.background }}>

                        <Grid container direction="row" justify="flex-start">
                            <Grid>
                                <Typography className={classes.title} style={{ color: props.textColor }}>
                                    {props.title}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container direction="row" justify="flex-end">
                            <Grid item  >
                                <Typography className={classes.number} style={{ color: props.textColor }}>
                                    {props.number}
                                </Typography>
                            </Grid>
                        </Grid>

                    </Paper>
            }

        </div>


    )
}

export default CardNumber